import {View, StyleSheet} from 'react-native';
import Text from '@/components/basic/text';
import React from 'react';
import theme from '@/style';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';
import CloseCircle from '@/components/svgs/basic/close-circle';
import {CurrencyMap} from '@services/currency';

const BetsItem = ({
  type = '',
  digit = '',
  rate = 3,
  onClose = () => {},
  basePrice,
}: {
  type?: string;
  digit?: string;
  rate?: number;
  onClose?: () => void;
  basePrice?: number;
}) => {
  return (
    <View style={styles.container}>
      <Text size="large" fontFamily="fontInterBold">
        {type}={digit}
      </Text>
      <Text color="#F15802" fontSize={14} fontFamily="fontInterBold">
        {CurrencyMap.default + basePrice}
      </Text>
      <View style={[styles.rateContainer]}>
        <Text
          color={theme.basicColor.white}
          fontSize={10}
          fontFamily="fontInterBold">
          x{rate}
        </Text>
      </View>
      <NativeTouchableOpacity style={[styles.close]} onPress={onClose}>
        <CloseCircle />
      </NativeTouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#F6F7FB',
    flexDirection: 'row',
    alignItems: 'center',
    height: 36,
    borderRadius: 18,
    paddingHorizontal: 16,
    marginBottom: 8,
    gap: 8,
  },
  rateContainer: {
    height: 16,
    borderRadius: 4,
    paddingHorizontal: 4,
    justifyContent: 'center',
    backgroundColor: theme.backgroundColor.orange,
  },
  close: {
    position: 'absolute',
    right: 0,
    top: -8,
  },
});

export default BetsItem;
